const firebaseConfig = {
    apiKey: "AIzaSyDzzqs2akAkUjYmReTqC-wjX3bRz2wJj1U",
    authDomain: "epic-eateries-238ce.firebaseapp.com",
    projectId: "epic-eateries-238ce",
    storageBucket: "epic-eateries-238ce.appspot.com",
    messagingSenderId: "245133039726",
    appId: "1:245133039726:web:40f7711f842c1856af6e7f"
};
export default firebaseConfig;